import React from 'react';
import { Box, Typography, Button, Grid, TextField, Select, MenuItem, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const FinancialBreakdown = ({ 
    financialItems, 
    handleFinancialItemChange, 
    handleRemoveFinancialItem, 
    handleAddFinancialItem 
}) => {
    return (
        <Box sx={{ mt: 3 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="subtitle1" fontWeight="bold">Financial Breakdown</Typography>
                <Button startIcon={<AddIcon />} size="small" onClick={handleAddFinancialItem}>Add Item</Button>
            </Box>
            {financialItems.length === 0 && (
                <Typography variant="body2" color="textSecondary" align="center" sx={{ py: 2 }}>
                    No financial items added yet. Click "Add Item" or use automated calculations above.
                </Typography>
            )}
            {financialItems.map((item, index) => (
                <Grid container spacing={1} key={index} mb={1} alignItems="center">
                    <Grid item xs={3}>
                        <Select
                            fullWidth
                            size="small"
                            value={item.item_type}
                            onChange={(e) => handleFinancialItemChange(index, 'item_type', e.target.value)}
                        >
                            <MenuItem value="revenue">Revenue</MenuItem>
                            <MenuItem value="cost">Cost</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Category"
                            value={item.category}
                            onChange={(e) => handleFinancialItemChange(index, 'category', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            fullWidth
                            size="small"
                            type="number"
                            placeholder="Amount"
                            value={item.amount}
                            onChange={(e) => handleFinancialItemChange(index, 'amount', parseFloat(e.target.value))}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton size="small" onClick={() => handleRemoveFinancialItem(index)}>
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Grid>
                </Grid>
            ))}
            
            {financialItems.length > 0 && (
                <Box sx={{ mt: 1, p: 1, bgcolor: '#f5f5f5', borderRadius: '4px' }}>
                    <Typography variant="subtitle2" align="right">
                        Total Net: {Math.round(financialItems.reduce((acc, current) => 
                            current.item_type === 'revenue' ? acc + current.amount : acc - current.amount, 0
                        )).toLocaleString()} SEK
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default FinancialBreakdown;
